'use client';

import { Container, Grid, Typography } from '@mui/material';

import { industries as industriesConfig } from '@/config/industries.config';
import colors from '@/styles/themes/colors';
import { IndustryData } from '@/types/industry.type';

import IndustryCard from './IndustryCard';
import styles from './IndustrySolutionsSection.module.scss';

interface IndustrySolutionsSectionProps {
  title: string;
  description: string;
  industries: IndustryData[];
}

const IndustrySolutionsSection = ({ title, description, industries }: IndustrySolutionsSectionProps) => {
  const industriesWithIcons = industries.map(industry => {
    const config = industriesConfig.find(i => i.id === industry.id);

    return {
      ...industry,
      icon: config?.icon,
    };
  });

  return (
    <Container component="section" maxWidth={false} disableGutters className={styles.container}>
      <Container maxWidth="xl">
        <Typography variant="h2" textAlign="center" className={styles.title}>
          {title}
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          color={colors.graytone300}
          mt={{ xs: 3, md: 4 }}
          maxWidth={684}
          mx="auto"
        >
          {description}
        </Typography>
      </Container>
      <Grid container mt={10.5} maxWidth={1440} marginInline="auto">
        {industriesWithIcons.map(industry => (
          <Grid size={{ xs: 6, md: 4, lg: 3 }} key={industry.id}>
            <IndustryCard industry={industry} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default IndustrySolutionsSection;
